/* eslint-disable default-case */
import React, { memo, useState } from "react";
import * as excelJs from "exceljs";
import { CloudUpload, ExitToApp } from "@mui/icons-material";
import { Backdrop, Button, CircularProgress, Tooltip } from "@mui/material";
import { Buffer } from "buffer";
import { showErrorSnackbar } from "../snackBar/snakbar";
import { axiosInstanceForLambda } from "../../library/Axios";
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import API_ENDPOINTS from "../../apiEndpoints";

function DbExportButton({
  dbItem,
  dashboardVariables,
  hideZeroBalance,
  hideGroupTotal,
  company,
  range,
  financialyearid,
  selectedTab,
  endDate,
  startDate,
  isDashboard = false,
  onDashboardExport,
  onExportClick
}) {
  const [loading, setLoading] = useState(false);

  const routeSelector = (selectedTab) => {
      switch(selectedTab){
          case 1:
            return `/exports/cash?startDate=${startDate}&endDate=${endDate}`;
          case 2:
            return `/exports/bank?startDate=${startDate}&endDate=${endDate}`;
          case 5:
            return `/exports/tds?startDate=${startDate}&endDate=${endDate}&option=TDSREC`;
          default:
            return `/exports/default?startDate=${startDate}&endDate=${endDate}`;
      }
  }
  const handleExport = async () => {
    setLoading(true);
    try {
      const requestData = {
        page: "Dashboard",
        type: dbItem,
        fromDate: dashboardVariables?.startdate,
        toDate: dashboardVariables?.enddate,
        includeOpeningBalance: dashboardVariables?.openingbalance,
        hideZeroBalance,
        hideGroupTotal,
        range,
        financialYearId:financialyearid,
      };

      const response = await axiosInstanceForLambda({
        method: "POST",
        url: API_ENDPOINTS.REACT_APP_EXPORT_URL,
        data: requestData,
      });

      if (response.status === 200) {
        const buffer = Buffer.from(response?.data);
        const blob = new Blob([buffer]);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;

        const currentDate = new Date();
        const formattedDate = currentDate.toISOString().slice(0, 10);
        a.download = `ledgerX_Export_${dbItem}_${formattedDate}.xlsx`;

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        showErrorSnackbar("Failed to export. Please try again.");
      }
    } catch (error) {
      console.error("Export Error:", error);
      showErrorSnackbar("Internal server error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleDashboardExport = () => {
    if (onDashboardExport) {
      onDashboardExport();
    }
  };

  return (
    <>
    {
      selectedTab === 5 ? (
      <Tooltip title="Export"  placement="bottom"
      >
        <Button
          disableRipple
          disableElevation
          variant="outlined"
          sx={{
            color: "primary.main",
            backgroundColor: "bodyGray.main",
            fontSize: "12px",
            border: "1px solid",
            borderColor: "bodyGray.main",
            height: "30px",
            boxShadow: `
  inset 0 0 0.5px 1px hsla(0, 0%, 100%, 0.075),
  0 0 0 1px hsla(0, 0%, 0%, 0.05),
  0 0.3px 0.4px hsla(0, 0%, 0%, 0.02),
  0 0.9px 1.5px hsla(0, 0%, 0%, 0.045),
  0 3.5px 6px hsla(0, 0%, 0%, 0.09)`,
            backgroundColor: "#f9f9fe",
            // marginLeft: { xs: "0px", sm: "20px" },
            // marginBottom: { xs: "20px", sm: "0px" },
            // height: "30px",
            minWidth: {xs:"50px", sm: "64px"},
            cursor:"pointer",            
          }}
        >
          {loading ? (
            <CircularProgress size={16} color="inherit" />
          ) : (
            <Link 
            to={routeSelector(selectedTab)}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}
            >
            <CloudUpload sx={{ color: '#ffa500',opacity:1 }} />
             </Link>
          )}
        </Button>
      </Tooltip>

      ) : isDashboard ? (
        <Tooltip title="Export Dashboard" placement="bottom">
          <Button
            disableRipple
            disableElevation
            variant="outlined"
            onClick={handleDashboardExport}
            sx={{
              color: "primary.main",
              backgroundColor: "bodyGray.main",
              fontSize: "12px",
              border: "1px solid",
              borderColor: "bodyGray.main",
              height: "30px",
              boxShadow: `
    inset 0 0 0.5px 1px hsla(0, 0%, 100%, 0.075),
    0 0 0 1px hsla(0, 0%, 0%, 0.05),
    0 0.3px 0.4px hsla(0, 0%, 0%, 0.02),
    0 0.9px 1.5px hsla(0, 0%, 0%, 0.045),
    0 3.5px 6px hsla(0, 0%, 0%, 0.09)`,
              backgroundColor: "#f9f9fe",
              minWidth: {xs:"50px", sm: "64px"},
              cursor:"pointer"
            }}
          >
            {loading ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              <CloudUpload sx={{ color: '#ffa500',opacity:1 }} />
            )}
          </Button>
        </Tooltip>
      ) : (
        <Tooltip title="Export" placement="bottom">
          <Button
            disableRipple
            disableElevation
            variant="outlined"
            onClick={onExportClick}
            sx={{
              color: "primary.main",
              backgroundColor: "bodyGray.main",
              fontSize: "12px",
              border: "1px solid",
              borderColor: "bodyGray.main",
              height: "30px",
              boxShadow: `
  inset 0 0 0.5px 1px hsla(0, 0%, 100%, 0.075),
  0 0 0 1px hsla(0, 0%, 0%, 0.05),
  0 0.3px 0.4px hsla(0, 0%, 0%, 0.02),
  0 0.9px 1.5px hsla(0, 0%, 0%, 0.045),
  0 3.5px 6px hsla(0, 0%, 0%, 0.09)`,
              backgroundColor: "#f9f9fe",
              minWidth: {xs:"50px", sm: "64px"},
              cursor:"pointer"
            }}
          >
            {loading ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              <CloudUpload sx={{ color: '#ffa500',opacity:1 }} />
            )}
          </Button>
        </Tooltip>
      ) 
    }
    
     

    </>
  );
}

export default memo(DbExportButton);
